export function textReveal() {
    const elements = document.querySelectorAll(".wave-text");
    if (!elements.length) return;

    // Track loader completion and Spline settling globally (shared across all elements)
    let loaderCompleted = false;
    let splineSettled = false;
    
    // Store element data for checking when loader completes
    const elementData = [];

    // Process each wave-text element independently
    elements.forEach((el) => {
        const lines = el.innerHTML.split(/<br\s*\/?>/i);
        el.innerHTML = "";

        // Prepare DOM structure (split into words, then chars) but don't animate yet
        lines.forEach((lineText, lineIndex) => {
            const lineWrapper = document.createElement("div");
            lineWrapper.style.display = "block";

            // Split by words (spaces) to preserve word-breaking capability
            const words = lineText.trim().split(/\s+/);
            
            words.forEach((word, wordIndex) => {
                // Add space before word (except first word)
                if (wordIndex > 0) {
                    const space = document.createTextNode(" ");
                    lineWrapper.appendChild(space);
                }
                
                // Wrap word in a span to allow word-breaking
                const wordSpan = document.createElement("span");
                wordSpan.className = "word";
                
                // Split word into characters for animation
                word.split("").forEach((char, charIndex) => {
                    const charSpan = document.createElement("span");
                    charSpan.className = "char";
                    charSpan.textContent = char;
                    // Set initial hidden state
                    charSpan.style.opacity = "0";
                    charSpan.style.filter = "blur(22px)";
                    wordSpan.appendChild(charSpan);
                });
                
                lineWrapper.appendChild(wordSpan);
            });

            el.appendChild(lineWrapper);
        });

        // Track state for this specific element
        let isInViewport = false;
        let animationStarted = false;

        // Function to check if element is currently in viewport
        const checkInViewport = () => {
            const rect = el.getBoundingClientRect();
            return rect.top < window.innerHeight && rect.bottom > 0;
        };

        // Function to start animation when all conditions are met
        const startAnimation = () => {
            // Check viewport status if not already set
            if (!isInViewport && checkInViewport()) {
                isInViewport = true;
            }
            
            if (animationStarted || !loaderCompleted || !splineSettled || !isInViewport) return;
            
            animationStarted = true;
            const tl = gsap.timeline({ delay: 0.2 });

            lines.forEach((lineText, lineIndex) => {
                const lineWrapper = el.children[lineIndex];
                if (!lineWrapper) return;

                // Get all character spans from all word spans in this line
                const chars = lineWrapper.querySelectorAll(".char");

                tl.fromTo(
                    chars,
                    {
                        opacity: 0,
                        filter: "blur(22px)",
                        y: i => 16 + Math.sin(i * 0.6) * 8
                    },
                    {
                        opacity: 1,
                        filter: "blur(0px)",
                        y: 0,
                        duration: 1,
                        ease: "power4.out",
                        stagger: 0.045
                    },
                    lineIndex === 0 ? 0 : "-=0.55" // 👈 overlap = continuous feel
                );
            });
            
            // Dispatch event when animation completes
            tl.eventCallback("onComplete", () => {
                el.dispatchEvent(new CustomEvent('textRevealComplete', { bubbles: true }));
            });
        };

        // Use Intersection Observer to detect when element enters viewport
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    isInViewport = true;
                    // Only start animation if loader has completed and Spline has settled
                    if (loaderCompleted && splineSettled) {
                        startAnimation();
                        // Unobserve after animation starts to prevent re-triggering
                        if (animationStarted) {
                            observer.unobserve(el);
                        }
                    }
                }
            });
        }, {
            threshold: 0.1, // Trigger when 10% of element is visible
            rootMargin: '0px'
        });

        observer.observe(el);

        // Store element data for loader completion check
        elementData.push({
            startAnimation,
            getAnimationStarted: () => animationStarted
        });
    });

    // Event listener for loader completion
    const handleLoaderCompleted = () => {
        loaderCompleted = true;
        // Check all elements that are in viewport and try to start their animations
        // But only if Spline has also settled
        if (splineSettled) {
            elementData.forEach(data => {
                if (!data.getAnimationStarted()) {
                    // startAnimation will check all conditions
                    data.startAnimation();
                }
            });
        }
    };

    // Event listener for Spline settling
    const handleSplineSettled = () => {
        splineSettled = true;
        // Check all elements that are in viewport and try to start their animations
        // But only if loader has also completed
        if (loaderCompleted) {
            elementData.forEach(data => {
                if (!data.getAnimationStarted()) {
                    // startAnimation will check all conditions
                    data.startAnimation();
                }
            });
        }
    };

    // Listen for both events
    document.addEventListener('loaderCompleted', handleLoaderCompleted);
    document.addEventListener('splineSettled', handleSplineSettled);
}